export function splitCommas(value, splitOn = ',') {
    let results = [];
    if (!value)
        return results;
    let lastCommaIndex = -1, currPos = 0, openParen = 0;
    while (currPos <= value.length) {
        let char = value.charAt(currPos);
        if (char === '(') {
            openParen++;
        }
        else if (char === ')') {
            openParen--;
        }
        else if (char === splitOn && !openParen) {
            if (lastCommaIndex + 1 === currPos) {
                results.push('');
            }
            else {
                results.push(value.substring(lastCommaIndex + 1, currPos));
            }
            lastCommaIndex = currPos;
        }
        currPos++;
    }
    if (lastCommaIndex <= value.length - 1) {
        results.push(value.substring(lastCommaIndex + 1));
    }
    return results;
}
